import {makeStyles} from "@material-ui/core";

export const buttonRedStyles = makeStyles(() => ({
    submit: {
      backgroundColor: "#DA2037",
      "&:hover": {
        backgroundColor: "#e84353",
      },
      marginTop: "30px",
      borderRadius: "20px",
      texttransform: "capitalize",
    }
  }));

export const buttonBlueStyles = makeStyles(() => ({
    submit: {
      backgroundColor: "#002c54",
      "&:hover": {
        backgroundColor: "#0a0052",
      },
      borderRadius: "20px",
    }
  }));

export const loginStyles = makeStyles(() => ({
    submit: {
      backgroundColor: "#DA2037",
      "&:hover": {
        backgroundColor: "#e84353",
      },
      "&.Mui-disabled": {
        backgroundColor: "#e3e3e3",
        color: "#9e9e9e",
      },
      marginTop: "28px",
      padding: "11px 0",
      borderRadius: "20px",
      fontWeight: 600,
      fontSize: "15px",
      textTransform: "capitalize",
      boxShadow: "0 8px 20px rgba(218,32,55,0.28)",
      transition: "0.2s ease-in-out all",
    },
    // Mantiene el botón rojo (con spinner blanco) mientras se envía,
    // en vez del gris del estado disabled.
    submitLoading: {
      "&.Mui-disabled": {
        backgroundColor: "#DA2037",
        color: "#ffffff",
      },
    },
    visibility: {
      color: "#757575",
    },
    txtForgotPass: {
      margin: "2px",
      texttransform: "capitalize",
      width: "100%",
      alignSelf: "center",
      textAlign: "center",
    },
    title: {
      color: "#002c54",
      textAlign: "center",
      padding: "10px",
    },
    iconButton: {
      "&:focus": {
        outline: "none !important",
      },
    },
  }));